export default __webpack_public_path__ + "static/media/LTikTok.90054aa4.svg";